import Vue from 'vue'

Vue.directive('elInputFocus', {
	// 当被绑定的元素插入到 DOM 中时……
	inserted: function (el, binding, vnode, oldVnode) {
		// 聚焦元素
		let input = el.querySelector('input.el-input__inner')
		input.addEventListener('focus', function () {
			vnode.componentInstance.clearValidate()
		})
	}
})



// WEBPACK FOOTER //
// ./src/directives/el-input-focus.js